module.exports = __webpack_public_path__ + "6fa12523b3a669a7cadc7d60a10fe417.png";